// 打字机效果 composable
import { ref, onMounted } from 'vue'

export function useTypewriter(textArr, speed = 80, pause = 1200) {
  const display = ref('')
  let idx = 0, charIdx = 0, forward = true

  function next() {
    if (forward) {
      if (charIdx < textArr[idx].length) {
        display.value += textArr[idx][charIdx++]
      } else {
        forward = false
        setTimeout(next, pause)
        return
      }
    } else {
      if (charIdx > 0) {
        display.value = display.value.slice(0, --charIdx)
      } else {
        forward = true
        idx = (idx + 1) % textArr.length
      }
    }
    setTimeout(next, speed)
  }

  onMounted(() => next())
  return display
}
